import {
  AI2Mark
} from "./chunk-DXBWUVYF.js";
import {
  AI2MarkText
} from "./chunk-VG5ROIV3.js";
import {
  color
} from "./chunk-KBRIPOOD.js";
import {
  __export
} from "./chunk-3EJPJMEH.js";

// src/components/logos/AI2Logo.tsx
var AI2Logo_exports = {};
__export(AI2Logo_exports, {
  AI2Logo: () => AI2Logo
});
import { styled } from "@mui/material";
import { jsx, jsxs } from "react/jsx-runtime";
var dimsBySize = {
  sm: {
    height: 16,
    width: {
      mark: 30,
      gap: 9,
      text: 138
    }
  },
  md: {
    height: 30,
    width: {
      mark: 64,
      text: 189,
      gap: 12
    }
  },
  lg: {
    height: 37,
    width: {
      mark: 79,
      gap: 14,
      text: 233
    }
  }
};
var LogoGrid = styled(({ gap, children, ...rest }) => /* @__PURE__ */ jsx("span", { ...rest, children }))`
    display: inline-grid;
    grid-template-columns: repeat(2, min-content);
    gap: ${({ gap }) => gap}px;
`;
function AI2Logo({
  size = "md",
  color: color2 = "default",
  includeText = true,
  className
}) {
  const dims = dimsBySize[size];
  const [gradients, myColor] = color2 === "white" ? [false, color.N2] : [void 0, void 0];
  if (!includeText) {
    return /* @__PURE__ */ jsx(
      AI2Mark,
      {
        className,
        width: dims.width.mark,
        height: dims.height,
        gradients,
        color: myColor
      }
    );
  }
  const vw = size === "sm" ? "74 6 190 18" : void 0;
  return /* @__PURE__ */ jsxs(LogoGrid, { gap: dims.width.gap, className, children: [
    /* @__PURE__ */ jsx(
      AI2Mark,
      {
        width: dims.width.mark,
        height: dims.height,
        gradients,
        color: myColor
      }
    ),
    /* @__PURE__ */ jsx(
      AI2MarkText,
      {
        width: dims.width.text,
        height: dims.height,
        color: myColor,
        viewBox: vw
      }
    )
  ] });
}

export {
  AI2Logo,
  AI2Logo_exports
};
//# sourceMappingURL=chunk-GYFBFKUL.js.map